import { render, staticRenderFns } from "./RowCheckbox.vue?vue&type=template&id=615fbea6"
import script from "./RowCheckbox.vue?vue&type=script&lang=js"
export * from "./RowCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports